module.exports = __webpack_public_path__ + "static/media/weatherApp.faa722a7.png";